export default __webpack_public_path__ + "static/media/others6.cb8f1c45.jpg";